module.exports = __webpack_public_path__ + "img/menu_bottom_7.4c2ec027.svg";